import {Overlay} from '@angular/cdk/overlay';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractPortalToOverlayComponent} from '../../../shared/components/abstract-portal-to-overlay/abstract-portal-to-overlay.component';
import {GlobalMessage, GlobalMessageType} from '../../models/global-message';

@Component({
    selector: 'app-global-message',
    templateUrl: './global-message.component.html',
    styleUrls: ['./global-message.component.scss']
})
export class GlobalMessageComponent extends AbstractPortalToOverlayComponent {
    @Input()
    messages: GlobalMessage[];

    @Output()
    dismiss = new EventEmitter<GlobalMessage>();

    constructor(overlay: Overlay) {
        super(overlay);
    }

    determineToolbarColor(message: GlobalMessage): string {
        switch (message.type) {
            case GlobalMessageType.ERROR:
                return 'warn';
            case GlobalMessageType.SUCCESS:
                return 'primary';
            default:
                return 'accent';
        }
    }

    dismissMessage(globalMessage: GlobalMessage) {
        this.dismiss.emit(globalMessage);
    }
}
